import { Link } from "react-router-dom";
import { useGlobalContext } from "../../context";
import "./homegotos.css";

const HomeGoTos = () => {
  const { goToTop } = useGlobalContext();

  return (
    <>
      <div className="gotoContainer">
        <h1 className="homeHeading">More!</h1>
        <div className="gotoItems">
          <Link
            to={"/blogs"}
            onClick={() => goToTop("art")}
            className="gotoItemAnchor"
          >
            <div className="gotoItem">
              <img
                src={process.env.PUBLIC_URL + "/gotos/blogs.png"}
                alt="blogs"
                className="gotoImg"
              />
              <span className="gotoName">My Blogs</span>
            </div>
          </Link>
          <a
            href="https://www.youtube.com/@sonubardai"
            target="_blank"
            className="gotoItemAnchor"
            rel="noreferrer"
          >
            <div className="gotoItem">
              <img
                src={process.env.PUBLIC_URL + "/gotos/youtube.png"}
                alt="youtube"
                className="gotoImg"
              />
              <span className="gotoName">My YouTube!</span>
            </div>
          </a>
          <Link
            to={"/art"}
            onClick={() => goToTop("art")}
            className="gotoItemAnchor"
          >
            <div className="gotoItem">
              <img
                src={process.env.PUBLIC_URL + "/gotos/art.png"}
                alt="artwork"
                className="gotoImg"
              />
              <span className="gotoName">My Artwork</span>
            </div>
          </Link>
          <Link
            to={"/about"}
            onClick={() => goToTop("about")}
            className="gotoItemAnchor"
          >
            <div className="gotoItem">
              <img
                src={process.env.PUBLIC_URL + "/gotos/about.png"}
                className="gotoImg"
                alt="about_me"
              />
              <span className="gotoName">About Me</span>
            </div>
          </Link>
          <Link
            to={"/contact"}
            onClick={() => goToTop("contact")}
            className="gotoItemAnchor"
          >
            <div className="gotoItem">
              <img
                src={process.env.PUBLIC_URL + "/gotos/contact.png"}
                className="gotoImg"
                alt="contact_me"
              />
              <span className="gotoName">Contact Me</span>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default HomeGoTos;
